import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_TITLE = 'Spaq株式会社｜電気を、もっと賢く、無駄なく。— 設計から制御まで、電力インテリジェンスを社会へ。';
const DEFAULT_DESCRIPTION = 'Spaq株式会社（SPAQ）は、太陽光発電の設計・コンサルティングで培った知見をもとに、導入判断を支える『1minute solar』と、現場の電力運用を支える『SPAQ CORE』を展開しています。企業ごとに異なる電気の使い方に向き合い、設備の検討から導入・運用までを支えます。';
export const SITE_ORIGIN = 'https://core.spaq.ltd';

interface SEOProps {
  title?: string;
  description?: string;
  canonicalPath?: string;
  noindex?: boolean;
}

export function SEO({ title, description, canonicalPath, noindex = false }: SEOProps) {
  const location = useLocation();

  useEffect(() => {
    // 1. Title
    const finalTitle = title
      ? (title.includes('Spaq') ? title : `${title}｜Spaq株式会社`)
      : DEFAULT_TITLE;
    document.title = finalTitle;

    // 2. Canonical URL (クエリパラメータ等を除去した正規パス)
    const cleanPath = canonicalPath || location.pathname;
    const normalizedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
    const canonicalUrl = `${SITE_ORIGIN}${normalizedPath === '/' ? '/' : normalizedPath}`;

    let canonicalEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', canonicalUrl);

    // 3. Meta Description
    const finalDesc = description || DEFAULT_DESCRIPTION;
    let descEl = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (descEl) {
      descEl.setAttribute('content', finalDesc);
    }

    // 4. Robots
    let robotsEl = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (robotsEl) {
      robotsEl.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');
    }

    // 5. Open Graph tags
    const ogTitleEl = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitleEl) ogTitleEl.setAttribute('content', finalTitle);

    const ogDescEl = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDescEl) ogDescEl.setAttribute('content', finalDesc);

    const ogUrlEl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (ogUrlEl) ogUrlEl.setAttribute('content', canonicalUrl);
  }, [title, description, canonicalPath, noindex, location.pathname]);

  return null;
}

export default SEO;
